export default __webpack_public_path__ + "static/media/About-me.31d23eeb.jpg";